import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { editTeam } from '../../api/requests';
import SelectDropdown from '../../components/form-control/SelectDropdown';
import { CheckBoxInput } from '../../components/form-control/CheckBoxInput';
import usePartner from '../../hooks/partnerHook';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from '../../utils/miscFunctions';

interface AddTeamToWorkspaceProps {
    onProceed: () => void;
    onClose: () => void;
    team: any;
}

const AddTeamToWorkspace = ({ onProceed, onClose, team }: AddTeamToWorkspaceProps) => {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const { getAllSlackWorkspaces } = usePartner();

    const { data: workspaces } = useQuery({ queryKey: ['workspaces'], queryFn: getAllSlackWorkspaces })


    return (
        <div className="w-full">

            <div className="p-5">
                <Formik
                    initialValues={{
                        address: team?.address,
                        corporatePhone: team?.corporatePhone,
                        email: team?.email,
                        mobilePhone: team?.mobilePhone,
                        name: team?.name,
                        type: team?.type,
                        slackWorkspaceId: team?.slackWorkspace,
                        addMembers: team?.addMembers ?? true,
                    }}
                    validateOnChange={false}
                    validateOnBlur
                    validationSchema={Yup.object({
                        slackWorkspaceId: Yup.string().trim().required('Select a workspace')
                    })}
                    onSubmit={(values) => {
                        const teamID = team.id
                        setSubmitting(true);

                        const payload = {
                            ...values,
                            slackWorkspaceId: values.slackWorkspaceId,
                            addMembers: values.addMembers,
                        };

                        useMutation({
                            mutationFn: () => editTeam(teamID, payload),
                            onSuccess: (response: any) => {
                                showToast.success(response?.message ?? 'Team added to slack workspace successfully',);
                                onProceed();
                            },
                            onError: (error: any) => {
                                showToast.error(error.description);
                            },
                            onSettled: () => {
                                setSubmitting(false);
                            }
                        })
                    }}>
                    {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <div className="space-y-5">
                                <SelectDropdown
                                    name="slackWorkspaceId"
                                    label="Slack Workspace"
                                    placeholder="Select workspace"
                                    listSelectedValue={values.slackWorkspaceId}
                                    wrapperClasses=""
                                    required
                                    onChange={(value: any) => {
                                        setFieldValue('slackWorkspaceId', value);
                                    }}
                                    list={workspaces?.map((workspace: any) => ({
                                        name: workspace?.name,
                                        value: workspace?.id
                                    })
                                    )}
                                />

                                {values.slackWorkspaceId &&
                                    <CheckBoxInput
                                        label={'Add members to workspace'}
                                        name={'addMembers'}
                                        checked={values?.addMembers}
                                        onChange={(value: boolean) => {
                                            setFieldValue("addMembers", value)
                                        }}
                                    />
                                }

                            </div>

                            <div className="w-full flex gap-4 mt-6 !mb-4">
                                <Button
                                type="button"
                                label="Cancel"
                                onClick={onClose}
                                bgColor='secondary'
                                fullWidth
                                loading={submitting}
                                disabled={submitting}
                                />
                                <Button
                                type="submit"
                                label="Submit"
                                bgColor='primary'
                                fullWidth
                                loading={submitting}
                                disabled={submitting}
                                />
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddTeamToWorkspace;
